var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import Accordion from '@/components/Accordion.vue';
import { listBitrix24Pipelines, listBitrix24Stages } from '@/clients/crm';
let BitrixDealConfig = class BitrixDealConfig extends Vue {
    constructor() {
        super(...arguments);
        this.selectedPipeline = '';
        this.selectedPipelineId = '';
        this.selectedStage = '';
        this.selectedStageId = '';
        this.listPipeline = [];
        this.loadingPipelines = false;
        this.listStages = [];
        this.loadingStages = false;
        this.tokenBitrix24 = '';
    }
    async mounted() {
        await this.getBitrixPipelines();
        if (this.cachedValues) {
            const { pipeline, stage } = this.cachedValues;
            const selectedPipeline = this.listPipeline.find(p => p.ID === pipeline);
            if (selectedPipeline) {
                this.selectedPipeline = selectedPipeline.ID;
                this.selectedPipelineId = selectedPipeline.ID;
                await this.updateSelectPipeline(this.selectedPipeline);
                await this.getBitrixStages(this.cachedValues.pipeline);
                const selectedStage = this.listStages.find(s => s.STATUS_ID == stage);
                if (selectedStage) {
                    this.selectedStage = selectedStage.STATUS_ID;
                    this.updateSelectStage(selectedStage.STATUS_ID);
                }
            }
        }
    }
    async getBitrixPipelines() {
        this.loadingPipelines = true;
        try {
            const response = await listBitrix24Pipelines();
            this.listPipeline = response.data.pipelines;
        }
        catch (e) {
            console.log(e);
        }
        this.loadingPipelines = false;
    }
    async getBitrixStages(pipelineId) {
        this.loadingStages = true;
        try {
            const response = await listBitrix24Stages(pipelineId);
            this.listStages = response.data.stages;
        }
        catch (e) {
            console.log(e);
        }
        this.loadingStages = false;
    }
    async updateSelectPipeline(pipelineId) {
        this.selectedPipelineId = pipelineId;
        if (pipelineId) {
            await this.getBitrixStages(pipelineId);
        }
        this.$emit('selectedPipelineAndStage', {
            pipeline: this.selectedPipelineId,
            stage: this.selectedStage,
        });
    }
    updateSelectStage(stageId) {
        this.selectedStageId = stageId;
        this.$emit('selectedPipelineAndStage', {
            pipeline: this.selectedPipelineId,
            stage: this.selectedStageId,
        });
    }
};
__decorate([
    Prop({ default: () => null })
], BitrixDealConfig.prototype, "cachedValues", void 0);
BitrixDealConfig = __decorate([
    Component({
        name: 'BitrixDealConfig',
        components: {
            Accordion,
        },
    })
], BitrixDealConfig);
export default BitrixDealConfig;
